/** Two people with arrows between them: one swapped for the other. */
export function SwapIcon({ size = 15 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <circle cx="6.5" cy="7" r="2.6" />
      <path d="M2 15.5c.6-2.6 2.2-4 4.5-4s3.9 1.4 4.5 4" />
      <circle cx="17.5" cy="11.5" r="2.6" />
      <path d="M13 20c.6-2.6 2.2-4 4.5-4s3.9 1.4 4.5 4" />
      <path d="M13 3.5h5.5M16.5 1.5l2 2-2 2" />
      <path d="M11 20.5H5.5M7.5 18.5l-2 2 2 2" />
    </svg>
  );
}
